// Helpers for correctly interpreting backend timestamps as UTC
// and displaying them in the user-selected timezone.

// Parse an ISO timestamp string coming from the backend.
// If the string has no timezone info, treat it as UTC.
export function parseBackendUtc(value) {
  if (!value) return null;
  if (value instanceof Date) return value;

  // If value already has a timezone designator (Z or +/-HH:MM), use as-is
  if (/[zZ]|[+\-]\d{2}:?\d{2}$/.test(value)) {
    return new Date(value);
  }

  // Assume naive timestamps from backend are UTC
  return new Date(value + 'Z');
}

export function formatDateTimeForTimezone(value, timezone) {
  const date = parseBackendUtc(value);
  if (!date) return '';
  return date.toLocaleString(undefined, {
    timeZone: timezone || 'UTC',
  });
}

export function formatDateForTimezone(value, timezone, locale = undefined, options = {}) {
  const date = parseBackendUtc(value);
  if (!date) return '';
  return date.toLocaleDateString(locale, {
    timeZone: timezone || 'UTC',
    ...options,
  });
}
